var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"main-wrapper"},[_c('div',[_c('p',[_vm._v(" Login... ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }